/* eslint-disable @typescript-eslint/no-explicit-any */

import { GenerateModuleOutput } from '@/api/gql/graphql';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type GeneratedStoreData = {
  generatedData: GenerateModuleOutput | null;
  isLoaded: boolean;
  setGeneratedData: (data: GenerateModuleOutput) => void;
  clearGeneratedData: () => void;
};

export const useGeneratedStoreData = create<GeneratedStoreData>()(
  persist(
    (set) => ({
      generatedData: null,
      isLoaded: false,
      setGeneratedData: (data) => {
        // Create a deep clone to ensure we don't have reference issues
        const clonedData = structuredClone(data);
        set({ generatedData: clonedData, isLoaded: true });
      },
      clearGeneratedData: () => set({ generatedData: null, isLoaded: false }),
    }),
    {
      name: 'generated-data-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        generatedData: state.generatedData,
        isLoaded: state.isLoaded,
      }),
      merge: (
        persistedState: unknown,
        currentState: GeneratedStoreData,
      ): GeneratedStoreData => ({
        ...currentState,
        ...(persistedState as Partial<GeneratedStoreData>),
      }),
      version: 1,
    },
  ),
);
